export default {
  setSalons(state, payload) {
    state.salons = payload;
  },
  setSalonDetails(state, payload) {
    state.salonDetails = { ...payload };
  },
  setVoucherStock(state, stock) {
    state.voucherStocksBySalonId[stock.salonId] = stock;
    const updateSalon = salon => Number(salon.id) === Number(stock.salonId)
      ? { ...salon, availableVouchers: stock.quantity }
      : salon;
    state.salons = state.salons.map(updateSalon);
    if (state.salonDetails?.salonDto) {
      state.salonDetails = { ...state.salonDetails, salonDto: updateSalon(state.salonDetails.salonDto) };
    } else if (state.salonDetails) {
      state.salonDetails = updateSalon(state.salonDetails);
    }
  },
  clearVoucherStock(state, salonId) {
    delete state.voucherStocksBySalonId[salonId];
  }
}
